window.BOLD = window.BOLD || {};
BOLD.BMS = BOLD.BMS || {}
BOLD.BMS.helpers = BOLD.BMS.helpers || {};

BOLD.BMS.helpers.debounce = function debounce(debounced_function, wait, identifier){
  var identifier = 'dbounce' + identifier + Math.random();
  return function(){
    var context = this, args = arguments
    BOLD.debounceIDs = BOLD.debounceIDs || {};
    clearTimeout(BOLD.debounceIDs[identifier+(this.id || this.name)]);
    BOLD.debounceIDs[identifier+(this.id || this.name)] = setTimeout(function(){ debounced_function.apply(context, args); delete BOLD.debounceIDs[identifier+this.id]; }, wait)
  }
};
